import { Question } from '../types';

// API service for fetching quiz questions
export async function fetchQuestions(): Promise<Question[]> {
    // If local API fails, return static data
    const staticQuestions = {
      "questions": [
        {
          "question": "Aký typ šperku Vás najviac oslovuje?",
          "options": [
            {"category": "A", "answer": "Klasické perly alebo diamanty"},
            {"category": "B", "answer": "Jednoduché retiazky alebo náušnice"},
            {"category": "C", "answer": "Veľké, nápadné náhrdelníky alebo náramky"},
            {"category": "D", "answer": "Šperky od konkrétneho dizajnéra alebo s abstraktným dizajnom"}
          ]
        },
        {
          "question": "Aký materiál šperkov uprednostňujete?",
          "options": [
            {"category": "A", "answer": "Zlato alebo platina"},
            {"category": "B", "answer": "Striebro alebo biele zlato"},
            {"category": "C", "answer": "Zlato s drahými kameňmi"},
            {"category": "D", "answer": "Netradičné kovy alebo kombinácia materiálov"}
          ]
        },
        {
          "question": "Aký typ šperku by ste si vybrali na špeciálnu príležitosť?",
          "options": [
            {"category": "A", "answer": "Perlový náhrdelník alebo diamantové náušnice"},
            {"category": "B", "answer": "Jemná retiazka alebo jednoduché náušnice"},
            {"category": "C", "answer": "Výrazný náhrdelník alebo masívny náramok"},
            {"category": "D", "answer": "Šperk od obľúbeného dizajnéra alebo s umeleckým dizajnom"}
          ]
        },
        {
          "question": "Ako vnímate šperky?",
          "options": [
            {"category": "A", "answer": "Symbol statusu alebo tradície"},
            {"category": "B", "answer": "Doplnok, ktorý dopĺňa osobný štýl"},
            {"category": "C", "answer": "Symbol luxusu a bohatstva"},
            {"category": "D", "answer": "Umelecké dielo alebo vyjadrenie osobnosti"}
          ]
        },
        {
          "question": "Aký je Váš obľúbený štýl obliekania?",
          "options": [
            {"category": "A", "answer": "Klasický a elegantný"},
            {"category": "B", "answer": "Minimalistický a nadčasový"},
            {"category": "C", "answer": "Extravagantný a výrazný"},
            {"category": "D", "answer": "Moderný a dizajnový"}
          ]
        },
        {
          "question": "Aké farby šperkov Vás najviac priťahujú?",
          "options": [
            {"category": "A", "answer": "Jemné a neutrálne (napr. biela, krémová, zlatá)"},
            {"category": "B", "answer": "Strieborná alebo biele zlato"},
            {"category": "C", "answer": "Sýte a výrazné (napr. rubínová červená, smaragdová zelená)"},
            {"category": "D", "answer": "Netradičné alebo kombinácia farieb"}
          ]
        },
        {
          "question": "Aký typ šperkov by ste si vybrali na každodenné nosenie?",
          "options": [
            {"category": "A", "answer": "Jemné perlové náušnice alebo zlatý náramok"},
            {"category": "B", "answer": "Jednoduché retiazky alebo náušnice"},
            {"category": "C", "answer": "Nápadné náušnice alebo náramok"},
            {"category": "D", "answer": "Dizajnový prsteň alebo náhrdelník"}
          ]
        },
        {
          "question": "Aké šperky by ste si vybrali ako investíciu?",
          "options": [
            {"category": "A", "answer": "Diamanty alebo perly"},
            {"category": "B", "answer": "Kvalitné strieborné alebo zlaté šperky"},
            {"category": "C", "answer": "Šperky s drahými kameňmi alebo od známych značiek"},
            {"category": "D", "answer": "Dizajnové šperky od renomovaných umelcov"}
          ]
        },
        {
          "question": "Aký je Váš postoj k trendom v oblasti šperkov?",
          "options": [
            {"category": "A", "answer": "Preferujem klasické kúsky, ktoré nikdy nevyjdú z módy"},
            {"category": "B", "answer": "Sledujem trendy, ale uprednostňujem jednoduchý a nadčasový dizajn"},
            {"category": "C", "answer": "Rada experimentujem s novými trendmi a výraznými kúskami"},
            {"category": "D", "answer": "Zaujímam sa o dizajnérske šperky a sledujem aktuálne dianie v oblasti umenia"}
          ]
        },
        {
          "question": "Aký je Váš názor na šperky s osobným významom?",
          "options": [
            {"category": "A", "answer": "Cením si rodinné dedičstvo a tradície"},
            {"category": "B", "answer": " Uprednostňujem jednoduché šperky bez prílišnej symboliky"},
            {"category": "C", "answer": "Mám rada šperky, ktoré vyjadrujú moju osobnosť a štýl"},
            {"category": "D", "answer": "Cením si šperky, ktoré majú umeleckú hodnotu a príbeh"}
          ]
        }
      ]
    };

    return staticQuestions.questions as Question[];
}
